export default __webpack_public_path__ + "static/media/CustomerCase12.adc258cd.png";